<template>
  <div>
    <el-col :md="12" :lg="12">
      <w-perf-widget @change-widget-view="changeWidgetView('FFIREDS', ...arguments)" :show-change-btn="false" :eventlevel="ffiredsData.eventlevel">
        <span slot="perfHeader">화재경보</span>
        <ul class="event-info-list" v-if="ffiredsViewIndex === 0" slot="perfBody">
          <w-perf-body-info v-for="data in ffiredsData.frontBody" :key="data.widgetKey" :widget-info="data" />
        </ul>
        <ul class="multi" v-if="ffiredsViewIndex === 0" slot="perfFooter">
          <w-perf-footer-h-info v-for="data in ffiredsData.frontFooter" style="width: 100%;" :key="data.widgetKey" :widget-info="data" />
        </ul>
      </w-perf-widget>
    </el-col>
  </div>
</template>

<script>
import clone from 'lodash/clone';
import { mapGetters } from 'vuex';
import { SENSOR } from '@/constants/summary';
import api from '@/api/performance/sensor/sensor';
import { getIntervalDatetimeParams } from '@/utils/date';
import WPerfWidget from '../../components/PerfWidget';
import WPerfBodyInfo from '../../components/PerfBodyInfo';
import WPerfFooterHInfo from '../../components/PerfFooterHInfo';
import WPerfFooterVInfo from '../../components/PerfFooterVInfo';
import WSummaryLineChart from '../../components/SummaryLineChart';

export default {
  name: 'WPerfFfiredsView',
  components: {
    WPerfWidget,
    WPerfBodyInfo,
    WPerfFooterHInfo,
    WPerfFooterVInfo,
    WSummaryLineChart,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      params: {
        managetypeId: 'FMS',
      },
      ffiredsViewIndex: 0,
      ffiredsData: { frontBody: [], backBody: [], frontFooter: [], backFooter: [], eventlevel: null },
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
    /**
     * [요약]탭 활성화시 데이터 재로드
     * @return {[type]} [description]
     * @author jda
     */
    active() {
      this.loadData();
    },
  },
  methods: {
    getIntervalDatetimeParams,
    /**
     * 전체 화면 load(Tab 활성화 시, 화면 갱신 시 호출)
     * @author jeee12
     */
    loadData() {
      if (!this.active) {
        return;
      }
      const startDatetime = this.getIntervalDatetimeParams(new Date(), 'hour', 12);
      Object.assign(this.params, {
        objId: this.selectedNode.obj.objId,
        startDatetime,
      });

      const widgetKeyList = ['FFIREDS'];
      widgetKeyList.forEach((widgetKey) => {
        const widgetKeyLower = widgetKey.toLowerCase();
        this.changeWidgetView(widgetKey, this[`${widgetKeyLower}ViewIndex`]);
      });
    },
    /**
     * 위젯 전면 또는 후면 데이터 로드
     * @author jeee12
     * @param  {String} widgetKey 위젯 key (rsctypeId)
     * @param  {Integer} viewIndex 위젯 viewIndex
     */
    changeWidgetView(widgetKey, viewIndex) {
      const widgetKeyLower = widgetKey.toLowerCase();
      this[`${widgetKeyLower}ViewIndex`] = viewIndex;
      // 데이터 로드
      if (this[`${widgetKeyLower}ViewIndex`] === 0) {
        // 전면 데이터 로드 함수 호출
        this.loadFrontData(widgetKey);
      } else {
        // 후면 데이터 로드 함수 호출
        this.loadBackData(widgetKey);
      }
    },
    /**
     * 전면 데이터 로드 함수
     * @author jeee12
     * @param  {String} widgetKey 로드할 위젯 종류
     */
    loadFrontData(widgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList: SENSOR.FFIREDS.FRONT,
        rscKey: '_', // 현재 rslt를 조회하는 위젯은 '_'를 Key로 사용함
      });
      api.getSummaryRscRsltList(widgetParam).then((response) => {
        if (response.data.success) {
          this[widgetKey.toLowerCase().concat('Data')].frontBody = response.data.data.body;
          this[widgetKey.toLowerCase().concat('Data')].frontFooter = response.data.data.footer;
          this[widgetKey.toLowerCase().concat('Data')].eventlevel = response.data.data.eventlevel;
        }
      });
    },
    /**
     * 후면 데이터 로드 함수
     * @author jeee12
     * @param  {String} widgetKey 로드할 위젯 종류
     */
    loadBackData(widgetKey) {
      const widgetParam = clone(this.params);
      Object.assign(widgetParam, {
        summaryWidgetKey: widgetKey,
        rscInfoList: SENSOR.FFIREDS.BACK[widgetKey],
        rscKey: '_', // 현재 rslt를 조회하는 위젯은 '_'를 Key로 사용함
      });
      api.getSummaryRscRsltBackList(widgetParam).then((response) => {
        if (response.data.success) {
          this[widgetKey.toLowerCase().concat('Data')].backBody = response.data.data.body;
          this[widgetKey.toLowerCase().concat('Data')].backFooter = response.data.data.footer;
          this[widgetKey.toLowerCase().concat('Data')].eventlevel = response.data.data.eventlevel;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/sensor/components/PerfFfiredsView.vue